import React from 'react'
import Profile from "./Profile";
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';


function Adminleft() {
function logout(){
  toast.success("ID is Logout")
  setTimeout(() => {
    navigate("/")
  }, 200);
}
  const navigate=useNavigate()
  return (
    <div id="mimin" class="dashboard">
        <div className="container-fluid mimin-wrapper">
          {/* start:Left Menu */}
          <div id="left-menu">
            <div className="sub-left-menu scroll">
            <div className="wheather"> <br /><br />
                      <div className="stormy rainy animated pulse infinite" title='Hero'>
                        <div className="shadow">Mr.H</div>
                      </div>
                      <div className="sub-wheather">
                        <div className="thunder"></div>
                        <div className="rain">
                          <div className="droplet droplet1" />
                          <div className="droplet droplet2" />
                          <div className="droplet droplet3" />
                          <div className="droplet droplet4" />
                          <div className="droplet droplet5" />
                          <div className="droplet droplet6" />
                        </div>
                      </div>
                    </div>
              <ul className="nav nav-list">
                <li className="active ripple">
                  <Link className="tree-toggle nav-header" to="/profile">
                    DashBoard
                    <span className="fa-angle-right fa right-arrow text-right" />
                  </Link>
                </li>
                <li className="active ripple">
                  <Link className="tree-toggle nav-header" to='/uploadpic'>
                    Upload Image
                    <span className="fa-angle-right fa right-arrow text-right" />
                  </Link>
                </li>
                <li className="active ripple">
                  <Link to="/uploadfile" className="tree-toggle nav-header">
                    Upload Certificate
                    <span className="fa-angle-right fa right-arrow text-right" />
                  </Link>
                </li>
                <li className="active ripple">
                  <Link to="/viewcontact" className="tree-toggle nav-header">
                    View Contact
                    <span className="fa-angle-right fa right-arrow text-right" />
                  </Link>
                </li>
                <li className="active ripple">
                  <Link className="tree-toggle nav-header" to='' onClick={logout}>
                    Logout
                    <span className="fa-angle-right fa right-arrow text-right" />
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          
        </div>
    </div>
  )
}

export default Adminleft